import React from 'react'
import { withTranslation } from "react-i18next";
import infoimg from "../../../assets/images/all/infoimg.svg";
import { TbInfoTriangle } from "react-icons/tb";

const GameClosedPopup = (props) => {

  return (
    <div className='information-img'>
      <h2>{props.t('information')}</h2>
      {/* <img src={infoimg} /> */}
      <TbInfoTriangle className="info-icon"/>
      <p>{props.t('Game_currently_unavailable')}</p>
    </div>
  )
}

export default withTranslation()(GameClosedPopup)
